import NextLink from 'next/link';
import useHelpers from 'hooks/helpers';
import Readtime from 'components/includes/Readtime';
import PressReleaseTypes from 'constants/pressRelease';
import { ArticleSearchResponse } from 'model/Article';
import styles from './PressReleaseCard.module.scss';

type Props = {
  fields: ArticleSearchResponse;
  parentBackground?: string;
};

const PressReleaseCard = ({ parentBackground = 'background-white', fields }: Props) => {
  const { localizeDate } = useHelpers();
  const pressReleaseType = PressReleaseTypes[fields.article_type];
  const cardBackground =
    parentBackground === 'background-white' ? 'background-digital-light-grey' : 'background-white';
  const publicationDate = fields.article_publication_date;

  return (
    <NextLink
      href={fields.article_url}
      className="d-block press-release-card h-100"
      prefetch={false}
    >
      <div className={`${styles['press-release-card__content']} h-100`}>
        <div className={`${cardBackground} py-3 px-2 d-flex flex-column h-100`}>
          <div className="d-flex">
            <time className={`section-header-small ${styles['no-break']}`}>
              {localizeDate(publicationDate)}
            </time>
          </div>
          <div className="d-flex flex-column flex-grow-1 justify-content-between">
            <div className="mt-2">
              <h5 className={`${styles['press-release-card__title']} line-clamp-4`}>
                {fields.article_title}
              </h5>
              {fields.article_strapline && (
                <p className="body-small text-grey line-clamp-4 mt-1">{fields.article_strapline}</p>
              )}
            </div>
            <Readtime
              articleType={pressReleaseType}
              duration={fields.article_duration}
              className="section-header-small mt-2"
            />
          </div>
        </div>
      </div>
    </NextLink>
  );
};

export default PressReleaseCard;
